/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { deleteSession, stopWatchingForOtherTabSessionChange } from "@insite/client-framework/Services/SessionService";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";


type HandlerType = Handler;

export const DeleteSession: HandlerType = () => {
    stopWatchingForOtherTabSessionChange(); // Prevent reload caused by this sign-out, which could interfere with the RedirectToHomePage step.
    return deleteSession();
};

export const FailedOrderAttemptPage: HandlerType = props => {
    const state = props.getState();
    const FailedOrderAttemptPageLink = getPageLinkByPageType(state, "FailedOrderAttemptPage")?.url || "/FailedOrderAttempt";
    window.location.href = FailedOrderAttemptPageLink;
};

export const chain = [DeleteSession, FailedOrderAttemptPage];

const XngFraudSignOut = createHandlerChainRunnerOptionalParameter(chain, {}, "XngFraudSignOut");
export default XngFraudSignOut;
